import React, { useContext, useEffect } from 'react';
import { GlobalSettingsContext } from '../firebase/GlobalSettingsContext';
import { UserDataContext } from '../firebase/UserDataContext';
import ResultsPage from '../pages/ResultsPage';
import ResultsV2 from '../pages/ResultsV2';
import ResultsDashboard from '../pages/ResultsDashboard';

import * as routes from '../routes/routes';
import { useLocation } from 'react-router';
import { ROLES } from '../components/misc/Utils';
import { useNavigate } from 'react-router-dom';
import LoadingSkeleton from '../components/misc/LoadingSkeleton';


const ResultsRouter = (props) => {
    const navigate = useNavigate()
    const location = useLocation()
    const { globalSettings } = useContext(GlobalSettingsContext)
    const { user } = useContext(UserDataContext)

    useEffect(() => {
        if (Object.keys(user).length > 0 && !user.loggedIn) {
            navigate(routes.SIGN_IN)
        }
    }, [user, navigate])
    switch (true) {
        case Object.keys(globalSettings).length === 0 || Object.keys(user).length === 0:
            return <LoadingSkeleton />
        case location.pathname.includes(routes.RESULTS_DASHBOARD):
            return <ResultsDashboard />
        case location.pathname.includes(routes.RESULTS_V2):
            return <ResultsV2 />
        case location.pathname.includes(routes.RESULTS_PAGE):
            return <ResultsPage />
        default:
            return <div>Unable to route you to the correct page. Please contact a system administrator</div>

    }
}

export default ResultsRouter
